import React, { useEffect } from 'react';
import { drag } from 'd3-drag';
import { select } from 'd3-selection';
import { NodeVariant } from '../types';
import NodeShape from './NodeShape';
import NodeLabel from './NodeLabel';
import NodeMenu from './NodeMenu';
import { DIAMOND_NODE_WIDTH, getNodeShape, MAX_LABEL_LENGTH, MAX_LABEL_LENGTH_DIAMOND_NODE } from './NodeShapeFactory';
import { useNodeState } from '../context/nodeState';
import { DEFAULT_CANVAS_HEIGHT, DEFAULT_CANVAS_WIDTH } from '../canvas/useInteractiveCanvasHelpers';
var InteractiveNode = function (_a) {
    var _b;
    var id = _a.id, label = _a.label, variant = _a.variant, fillColor = _a.fillColor, textColor = _a.textColor, borderColor = _a.borderColor, height = _a.height, withShadow = _a.withShadow, menuItems = _a.menuItems;
    var _c = useNodeState(id), position = _c[0], nodeShape = _c[1], moveNode = _c[2], addNodeShapeToContext = _c[3];
    useEffect(function () {
        if (!position) {
            moveNode(Math.random() * DEFAULT_CANVAS_WIDTH, Math.random() * DEFAULT_CANVAS_HEIGHT);
        }
    }, [position]);
    useEffect(function () {
        if (!nodeShape) {
            addNodeShapeToContext(getNodeShape(variant, label, height));
        }
    }, [nodeShape]);
    useEffect(function () {
        if (position && nodeShape) {
            var dragBehavior = drag()
                .on('drag', function (e) {
                moveNode(e.dx, e.dy);
            });
            select(".node-" + id)
                .call(dragBehavior);
        }
    }, [position, nodeShape]);
    if (!position || !nodeShape) {
        return null;
    }
    var nodeWidth = 'width' in (nodeShape === null || nodeShape === void 0 ? void 0 : nodeShape.attrs) ? (_b = nodeShape === null || nodeShape === void 0 ? void 0 : nodeShape.attrs) === null || _b === void 0 ? void 0 : _b.width : DIAMOND_NODE_WIDTH;
    var maxLabelLength = variant === NodeVariant.DIAMOND ? MAX_LABEL_LENGTH_DIAMOND_NODE : MAX_LABEL_LENGTH;
    return (React.createElement("g", { className: "interactiveNode node-" + id, transform: "translate(" + position.x + "," + position.y + ")" },
        React.createElement(NodeShape, { shape: nodeShape, fillColor: fillColor, borderColor: borderColor, withShadow: withShadow }),
        React.createElement(NodeLabel, { label: label, maxLabelLength: maxLabelLength, textColor: textColor }),
        React.createElement(NodeMenu, { buttonColor: textColor, nodeWidth: nodeWidth, menuItems: menuItems })));
};
export default InteractiveNode;
//# sourceMappingURL=InteractiveNode.js.map